<template>
    <div>
        <b-container fluid>
            <b-jumbotron fluid class="jumbo">
                <template v-slot:header >mMGE: Human metagenomic eMGE database</template>
                <template v-slot:lead>
                    <p>
                        mMGE integrates extrachromosomal mobile genetic elements(eMGEs) derived from more than <span style="color:red;font-weight: bold;">66,425 </span> human metagenomic samples.
                    </p>
                </template>

                <hr class="my-4">
                <p>In mMGE:
                    <ul>
                        <li>We detected eMGEs(plasmids + phages) from more than 66,425 metagenomic samples</li>
                        <li>Comprehensive annotation for eMGEs were done, including:
                        <ul>
                            <li>Host assignment</li>
                            <li>Taxonomy affiliation</li>
                            <li>Protein annotation</li>
                            <li>Grouping eMGEs into eMGE clusters</li>
                            <li>Quality and completeness estimation</li>
                            <li>prevelance of eMGEs clusters across phenotypes, body sites and populations.</li>
                        </ul>
                        </li>
                    </ul>
                </p>

            </b-jumbotron>
            <b-row>
                <b-container>
                    <b-row>
                        <b-col class="ml-auto">
                            <b-card title="" align=center style="margin-top:5px">
                                <b-row>
                                    <b-col>
                                        <h4>eMGE bodysite distribution</h4>
                                        <div id="treeCanvas">
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-card style="margin-top:5px">
                                <b-row >                                    
                                    <b-col v-show="!showMap" sm="6" md="12" lg="6" >
                                        <div class="text-center m-5">
                                                <b-spinner class="align-middle"></b-spinner>
                                                <strong>&nbsp;Loading...</strong>
                                        </div>
                                    </b-col>
                                    <b-col v-show="showMap" style="height:300px" sm="6" md="12" lg="6" >
                                        <div id="chartdiv" style="height:100%"></div>
                                    </b-col>
                                    <b-col sm="6" md="12" lg="6" >
                                        <!-- some description -->
                                        <h4>Habitat distribution of eMGEs:</h4>
                                        <!-- <p style="align:justify"><span v-html="countryDistHtmltxt"></span></p> -->
                                        <p>We first collected 370 projects from various metagenomic databse sources,summing to 80,889 samples covering across 49 countries. After quality control, we identified 517,251 eMGEs including 424,759 phages and 92,492 plasmids from 66,425 samples which was later used for further analysis across all sample set . 2.5% of eMGEs are detected in more than 50% of countries, and 49.5% of eMGEs are detected in only one country. We grouped these eMGEs into 70,074 eMGE clusters, and host was assigned for 115,072 eMGEs through  Bioinformatic methods(CRISPR spacer match, sequence similarity, tRNA match).</p>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="ml-auto">
                            <b-card title="" align=justify style="margin-top:5px">
                                <b-row >
                                    <b-col sm="6" md="12" lg="6" >
                                        <!-- some description -->
                                        <br>
                                        <h4>Putative associations with human phenotypes:</h4>
                                        <!-- <p><span v-html="diseaseDistHtmltxt"></span></p> -->
                                        <p>The Phenotype distribution pie chart was calculated from 66,425 samples spanning more than 110 phenotypes. Metadata of each sample was collected from NCBI and associated papers. Among these eMGEs, 19.3% can be detected in multiple human phenotypes ( > 5), while 48.6% of eMGEs can be detected in only one phenotype. </p>
                                    </b-col>
                                    <b-col v-show="!showDPie" style="height:450px" sm="6" md="12" lg="6" >
                                        <div class="text-center m-5">
                                                <b-spinner class="align-middle"></b-spinner>
                                                <strong>&nbsp;Loading...</strong>
                                        </div>
                                    </b-col>
                                    <b-col v-show="showDPie" sm="6" md="12" lg="6" >
                                        <Plotly :data="diseasePie" :layout="dPieLayout" :autoResize="true"></Plotly>
                                    </b-col>                                    
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>                    
                </b-container>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
const _ = require("underscore")
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from '@amcharts/amcharts4-geodata/worldLow'
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import CountryMap from './CtryMap'
import { SVG } from '@svgdotjs/svg.js'

export default {
    data () {
        return{
            server_add:"https://mai.fudan.edu.cn/",
            graphData:[
            ],
            map:null,
            colorCache: {},
            showMap:false,
            showDPie:false,
            diseasePie:[],
            dPieLayout:{
                title:'Phenotype distribution',
            },
            txtLabelMap:{},
            banh1HtmlTxt:'HeMGE integrates the extrachromosomal mobile genetic elements (eMGEs) fragments derived from more than 80,000 human metagenomic sample across different countries, bodysites, and diseases.',
            banp1HtmlTxt:'Database of extrachromosomal mobile components(plasmid + phage) in different human bodysites',
            countryDistHtmltxt:'',
            diseaseDistHtmltxt:''
        }
    },
    mounted() {
        this.loadDesc()
        this.initMap()
        // this.loadMgeDat()
        this.loadBodySiteStat()
        this.loadCountryStat()
        this.loadDiseaseStat()
        this.loadHumanBodyMap()
    },
    methods: {
        loadHumanBodyMap(){
            var draw = SVG().addTo('#treeCanvas').size(300, 600)
            var svgContainer = draw.size('100%', '100%').viewbox(0, 0, 600, 450)
            var human_layer = svgContainer.group().id('human_layer')
            var organs_layer = human_layer.group().id('organs_layer')
            var bg_layer = human_layer.group().id('bg_layer')
            var image = bg_layer.image('images/human.png').size('50%', '50%')//.move(-120,-200)

            var organMap = []
            var organInfo = 'lung;lung.png;Lung,lymph-nodes;lymphnodes.png;Lymphatic system,gut;largeintestine.png;Gut,blood;blood.png;Blood,skin;skin.png;Skin,urethra;urethra.png;Urethra,tooth;tooth.png;Tooth,nose;nose-1.png;Nasopharyngeal,sputum;sputum.png;Sputum,oral-cavity;oral-cavity.png;Oral cavity'.split(',')
            for(var ind in organInfo){
                var organ = organInfo[ind].split(';')
                organMap.push({'id':organ[0],'name':organ[2],imgNorm:'images/'+organ[1],'pt':{}})
            }
            
            var pos = 0
            var radi = organMap.length*18
            for(var indx in organMap){
                var orga = organMap[indx]
                var pt = this.genPointOncircle(radi, pos, organMap.length)
                orga.pt = pt
                pos++
            }
            for(var i in organMap){
                var or = organMap[i]
                var organ_svg = organs_layer.image(or.imgNorm).size(30,30).move(or.pt.x,or.pt.y).id(or.id)
                organ_svg.mouseover(function(evt) {
                    this.transform({scale:2})
                })
                organ_svg.mouseout(function(){
                    this.transform({scale:1})
                })
                var txt = null,mgeTxt = null,samTxt = null
                txt = organs_layer.text(or.name.toUpperCase())
                mgeTxt = organs_layer.text('MGE:')
                samTxt = organs_layer.text('Samples:')
                txt.font({
                    size:9,
                    weight:'bold'
                })
                mgeTxt.font({
                    size:6,
                    weight:'bold'
                })
                samTxt.font({
                    size:6,
                    weight:'bold'
                })
                // console.log(organ_svg.id(),or.pt.angle,or.pt.angle >= -11,txt.length())

                if(or.pt.angle >= 2 && or.pt.angle <=4.5){
                    if(txt.length()<=22){
                        txt.move(or.pt.x-txt.length()-15,or.pt.y)
                    }else{
                        txt.move(or.pt.x-txt.length(),or.pt.y)
                    }
                    txt.transform({rotation:or.pt.angle,cx:0,cy:0})
                    mgeTxt.move(txt.x(),or.pt.y+10)
                    samTxt.move(txt.x(),or.pt.y+17)
                }else{                    
                    txt.move(or.pt.x+(30),or.pt.y)
                    txt.transform({rotation:or.pt.angle,cx:0,cy:0})
                    mgeTxt.move(txt.x(),or.pt.y+10)
                    samTxt.move(txt.x(),or.pt.y+17)
                }                                
                this.txtLabelMap[or.name] = {'mge':mgeTxt,'sam':samTxt}
            }            
            bg_layer.move(-140,-100)
            human_layer.move(70,20)
        },
        genPointOncircle(r, currentPoint, totalPoints){
            var startPt = {}
            var theta = ((Math.PI*2) / totalPoints);
            var angle = (theta * currentPoint);
            startPt.x = (r * Math.cos(angle));
            startPt.y = (r * Math.sin(angle));
            startPt.angle = angle
            return startPt
        },        
        // loadMgeDat(){
        //     axios.post(this.server_add+'query/listMgeStat',
        //     {
        //     }).then(retDat => {
        //         // console.log(retDat)
        //         if(retDat.status === 200){
        //             var baseDat = retDat.data
        //             this.loadMapCharts(baseDat)
        //             this.formDiseaseStat(baseDat)
        //             this.loadOrganStat(baseDat)
        //         }
        //     }).catch(err => {
        //         console.log(err)
        //     })
        // },
        loadBodySiteStat(){
            axios.post(this.server_add+'query/listBodysiteStat',
            {
            }).then(retDat => {
                // console.log(retDat)
                if(retDat.status === 200){
                    var baseDat = retDat.data
                    this.loadOrganStat(baseDat)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadCountryStat(){
            axios.post(this.server_add+'query/listCountryStat',
            {
            }).then(retDat => {
                // console.log(retDat)
                if(retDat.status === 200){
                    var baseDat = retDat.data
                    this.loadMapCharts(baseDat)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadDiseaseStat(){
            axios.post(this.server_add+'query/listDiseaseStat',
            {
            }).then(retDat => {
                // console.log(retDat)
                if(retDat.status === 200){
                    var baseDat = retDat.data
                    this.formDiseaseStat(baseDat)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        initMap(){
            this.map = am4core.create("chartdiv", am4maps.MapChart);
            this.map.geodata = am4geodata_worldLow;
            this.map.projection = new am4maps.projections.Miller();
            this.map.zoomControl = new am4maps.ZoomControl();
            
            let title = this.map.titles.create();
            title.text = "Geographical distribution";
            title.fontSize = 19;
            title.marginBottom = 30;

            var button = this.map.chartContainer.createChild(am4core.Button);
            button.padding(5, 5, 5, 5);
            button.align = "right";
            button.marginRight = 15;
            var that = this
            button.events.on("hit", function() {
                that.map.goHome();
            });
            button.icon = new am4core.Sprite();
            button.icon.path = "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
        },
        loadMapCharts(baseDat){
            var grp = _.groupBy(baseDat,'Country')
            var ctryMap = CountryMap.getCtryMap()
            var that = this
            var all_dat = []            
            Object.keys(grp).forEach(function(key) {
                var res = that.procCtryName(key,grp[key][0].count,ctryMap)
                if(res.length>=1){
                    all_dat.push.apply(all_dat,res)
                }
            });
            var polygonSeries = this.map.series.push(new am4maps.MapPolygonSeries());
            polygonSeries.data = all_dat            
            var polygonTemplate = polygonSeries.mapPolygons.template;
            polygonTemplate.tooltipText = "{name}(Sample count:{value})";
            polygonTemplate.propertyFields.fill = "fill";
            polygonSeries.useGeodata = true;
            this.showMap = true
            this.map.homeZoomLevel = 8;
            this.map.goHome()
        },
        procCtryName(countryName,size,ctryMap){
            var sub = countryName.replace(' AND ',',').replace(' and ',',').replace(' OR ',',').replace(' or ',',').split(',')
            var ctrAr = []
            for(var ind in sub){
                var su = sub[ind]                
                if(ctryMap.has(su)){
                    ctrAr.push({'name':su,'id':ctryMap.get(su),'value':size,'fill':this.randomColor(ctryMap.get(su))})
                }else{
                    if(su.includes('United States of America')){
                        ctrAr.push({'name':'United States','id':'US','value':size,'fill':this.randomColor('US')})
                    }
                }
            }
            return ctrAr
        },
        randomColor(id) {
            const r = () => Math.floor(256 * Math.random());
            return this.colorCache[id] || (this.colorCache[id] = `rgb(${r()}, ${r()}, ${r()})`);
        },
        formDiseaseStat(baseDat){
            var grp = _.groupBy(baseDat,'Disease')
            var keyMap = Object.keys(grp)
            var szMap = Object.values(grp).map(p=>p[0].count)
            var phenoAr = Object.values(grp).map(p=>p[0]['DiseaseName'])
            var total = szMap.reduce((a, b) => a + b)
            var text = szMap.map((v, i) => `${keyMap[i]}<br>${'Sample count:'+v}<br>${parseFloat(v / total * 100).toFixed(1)}%<br>${'Phenotype:'+phenoAr[i]}`)
            this.diseasePie = [{
                type: "pie",
                values: szMap,
                labels: keyMap,
                text:text,
                textinfo:'none',
                hoverinfo: 'text'
                // hovertemplate : "%{label}: <br>Sample No: %{values}<br>Percent: %{percent} </br> %{text}"
                // textinfo: "label+percent",
                // textposition: "outside",
                // automargin: true
            }]
            this.showDPie = true
        },
        loadOrganStat(baseDat){
            var grp = _.groupBy(baseDat,'BodySite')
            var keyMap = Object.keys(grp)
            keyMap.forEach(id=>{
                var mgsub = grp[id][0].mge//_.groupBy(grp[id],'MGEs_id')
                var samsub = grp[id][0].sample//_.groupBy(grp[id],'NCBI_Run_ID')
                if(Object.prototype.hasOwnProperty.call(this.txtLabelMap, id)){
                    this.txtLabelMap[id].mge.text('MGE:'+mgsub)
                    this.txtLabelMap[id].sam.text('Samples:'+samsub)
                }
            })
        },
        loadDesc(){
            axios.post(this.server_add+'query/getPageCont',
            {
                route:'home'
            }).then(retDat => {                
                // console.log(retDat)
                if(retDat.status === 200){
                    var res = retDat.data
                    var grp = _.groupBy(res,'regKey')
                    this.banh1HtmlTxt = grp['banh1'][0]['content']
                    this.banp1HtmlTxt = grp['banp1'][0]['content']
                    this.countryDistHtmltxt = grp['cdistp1'][0]['content']
                    this.diseaseDistHtmltxt = grp['ddistp1'][0]['content']
                }
            }).catch(err => {
                console.log(err)
            })
        }
    },
}

</script>


<style scoped lang = "less">
   .jumbo{
       text-align: left;

       p{
            font-size: 0.9em;
        }

        h1{
            font-size: 2.0em;
        }
   } 
</style>

